import React from 'react';
import moment from 'moment';
import './date-tabs.scss';

interface DateTabsProps {
	date: { date: string; day: string };
	dateFormat: string;
}

const DateTabLabel = (props: DateTabsProps) => {
	const { date, dateFormat } = props;

	return (
		<div className="date-option" data-test-id={moment(date.date).format(dateFormat)}>
			<div className="date-option-day">{date.day}</div>
			<div className="date-option-date">{moment(date.date).format(dateFormat)}</div>
		</div>
	);
};

export default DateTabLabel;
